import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import BaseLayout from '../../components/BaseLayout';
import ButtonPrimary from '../../components/Buttons/Button';
import { Heading } from '../../components/Heading';
import { PAGES } from '../../constants/pages';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <BaseLayout halfScreen noLogoBox>
      <Heading textAlign="center" fontWeight={700} mb={28}>
        {t('common.pageNotFoundError')}
      </Heading>
      <Heading textAlign="center" fontWeight={700} mb={28}>
        {t('common.pageNotFound')}
      </Heading>
      <ButtonPrimary
        title={t('common.goBack')}
        onClick={() => history.push(PAGES.BASE)}
      />
    </BaseLayout>
  );
};

NotFoundPage.propTypes = {};

export default NotFoundPage;
